var _defs, _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-color-icon{fill:#f8f7f7;}.b-color-icon{fill:#efefef;}.c-color-icon{fill:#fff;opacity:0;}.d-color-icon{fill:#484848;}.e-color-icon{fill:red;}.f-color-icon{fill:none;stroke:#484848;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.75px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a-color-icon",
    width: 31,
    height: 24,
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b-color-icon",
    d: "M0,0H3a8,8,0,0,1,8,8v8a8,8,0,0,1-8,8H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(20)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68 -180)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c-color-icon",
    width: 24,
    height: 16,
    transform: "translate(72 184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-color-icon",
    d: "M75.48,194.995,79.19,186h1.377l3.953,8.995H83.064l-1.127-2.724H77.9l-1.06,2.724Zm2.787-3.693h3.275l-1.008-2.492q-.462-1.136-.686-1.865a10.9,10.9,0,0,1-.52,1.718Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e-color-icon data-color-line",
    width: 10,
    height: 2,
    transform: "translate(75 196)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f-color-icon",
    d: "M90,191l2,2,2-2",
    transform: "translate(1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIcon);
export default __webpack_public_path__ + "static/media/colorIcon.ddbb0a8b252c25663fb102fad6f203f1.svg";
export { ForwardRef as ReactComponent };